import React from 'react';
import StatusBadge from './StatusBadge';

/** Small marker for an amount in another currency that has no exchange rate,
 *  so it cannot be counted in the project's totals. */
export function UnconvertedMark({ currency }: { currency?: string | null }) {
  return (
    <StatusBadge
      variant="warning"
      title={`No exchange rate${currency ? ` for ${currency}` : ''}, so this amount is not counted in totals`}
    >
      unconverted
    </StatusBadge>
  );
}

/** Visible note under a total when some amounts were left out of it. */
export function UnconvertedNote({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <p className="ui-unconverted-note" role="note">
      {count === 1
        ? '1 amount has no exchange rate and is not counted in this total.'
        : `${count} amounts have no exchange rate and are not counted in this total.`}
    </p>
  );
}
